import { useState, useEffect, useCallback, useMemo } from 'react';
import { usePromptStore } from '../../../store/promptManager';

interface CustomPromptEditorProps {
  documentId: string;
  initialValue?: string;
  onSave: (prompt: string) => void;
}

const CustomPromptEditor = ({ documentId, initialValue = '', onSave }: CustomPromptEditorProps) => {
  const [promptText, setPromptText] = useState(initialValue);
  
  // 直接获取整个store以及所需的状态
  const documentSettings = usePromptStore(state => state.documentSettings);
  
  // 获取当前文档的设置
  const currentDocSettings = useMemo(() => 
    documentSettings[documentId], 
    [documentSettings, documentId]
  );
  
  // 当文档ID或设置变化时更新内容
  useEffect(() => {
    if (currentDocSettings?.customPrompt) {
      setPromptText(currentDocSettings.customPrompt);
    } else {
      setPromptText('');
    }
  }, [documentId, currentDocSettings]);
  
  const handleSave = useCallback(() => {
    onSave(promptText);
  }, [onSave, promptText]);
  
  const handleClear = useCallback(() => {
    setPromptText('');
    onSave('');
  }, [onSave]);
  
  // 使用useMemo计算禁用状态
  const isSaveDisabled = useMemo(
    () => promptText === currentDocSettings?.customPrompt,
    [promptText, currentDocSettings]
  );
  
  const isClearDisabled = useMemo(
    () => !promptText,
    [promptText]
  );
  
  return (
    <div className="custom-prompt-editor">
      <p>为当前文档添加自定义提示词，它将与所选模板一起应用：</p>
      
      <textarea
        value={promptText}
        onChange={(e) => setPromptText(e.target.value)}
        placeholder="输入自定义提示词..."
      />
      
      <div className="editor-actions">
        <button 
          className="editor-button" 
          onClick={handleSave}
          disabled={isSaveDisabled}
        >
          保存
        </button>
        
        <button 
          className="editor-button secondary" 
          onClick={handleClear}
          disabled={isClearDisabled}
        >
          清除
        </button>
      </div>
    </div>
  );
};

export default CustomPromptEditor; 